import React, { Component } from 'react';
import {Link} from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import FlatButton from "material-ui/FlatButton/index";
import ContentCreate from "material-ui/svg-icons/content/create";
import { TextInput } from "components/input";
import HiddenInput from "components/input/HiddenInput";
import { List, Datagrid, FilterForm } from 'components/list';
import { TextField } from 'components/field';

import * as utils from './utils';
import * as urls from "./urls";
import { saveDataRecordSelected } from "actions/recordSelectedActions";
import { showNotification } from "actions/notificationActions";


const PremiumShopFilter = (props) => (
  <FilterForm {...props} initialValues={ props.defaultSearchValue }>
    <TextInput source="mobile_number" label="Owner mobile"/>
    <TextInput source="shop_id" label="Shop ID"/>
    <HiddenInput source='shop_type' />
  </FilterForm>
);

class ViewPremiumShopDetailButton extends Component {
  constructor(props) {
    super(props);
    this.saveCurrentShopData = this.saveCurrentShopData.bind(this);
    this.clickDeactivateButton = this.clickDeactivateButton.bind(this);
  }

  saveCurrentShopData() {
    this.props.dispatch(saveDataRecordSelected(utils.PremiumShopResourceName, this.props.record));
  }

  clickDeactivateButton() {
    const currentSelectedShopData = this.props.record;
    if ( currentSelectedShopData.chain_info.active_count > 1) {
      this.props.dispatch(showNotification('Please un-merge all branches before deactivation', 'warning'));
    }
  }

  render() {
    const {record} = this.props;
    return (
      <div onClick={this.saveCurrentShopData}>
        <FlatButton
          primary
          label='Unmerge branch'
          icon={<ContentCreate />}
          containerElement={<Link to={urls.premiumShopUnmergeBranchFrontendPath} />}
          style={{ overflow: 'inherit' }}
        />

        <FlatButton
          primary
          label='Transfer primary'
          icon={<ContentCreate />}
          containerElement={<Link to={urls.premiumShopTransferPrimaryFrontendPath} />}
          style={{ overflow: 'inherit' }}
        />

        <FlatButton
          primary
          label='Deactivate'
          icon={<ContentCreate />}
          onClick={this.clickDeactivateButton}
          containerElement={ record && record.chain_info.active_count > 1 ? <span /> :
            (<Link to={ urls.premiumShopDeactivateFrontendPath} />) }
          style={{ overflow: 'inherit' }}
        />
      </div>
    )
  }
}
const ViewPremiumShopDetailButtonConnected = connect()(ViewPremiumShopDetailButton);

class PremiumShopList extends Component {

  render() {
    const {filterValues} = this.props;
    let autoLoadData = false;
    if (filterValues && Object.keys(filterValues).length > 0) {
      autoLoadData = true;
    }

    return (
      <List
        {...this.props}
        filters={<PremiumShopFilter defaultSearchValue={filterValues} />}
        autoLoadData={autoLoadData}
      >
        <Datagrid bodyOptions={{ stripedRows: true, showRowHover: true }}>
          <TextField source="chain_info.chain_id" label="Chain ID"/>
          <TextField source="shop_id" label="Shop ID"/>
          <TextField source="shop_info.owner_mobile_number" label="Owner mobile"/>
          <TextField source="shop_info.owner_name" label="Owner name"/>
          <TextField source="chain_info.active_count" label="Branch"/>
          <TextField source="chain_info.branch_count" label="Branch limit"/>
          <TextField source="chain_info.end_time" label="Expire time"/>
          <ViewPremiumShopDetailButtonConnected />
        </Datagrid>
      </List>
    )
  }
}

export default connect(
  state => ({
    filterValues: state.admin.filter[utils.PremiumShopResourceName],
  })
)(PremiumShopList);



// WEBPACK FOOTER //
// ./src/routes/advancedFunction/PremiumShopList.js